import { Injectable } from '@angular/core';
import { Coords } from '../../elements/resource/types/shape.type';
import { TextShape } from '../shape/shapes/text/text-shape';
import { GloveDefinition } from '../shape/background.service';
export type TransitionType = 'fade' | 'blur';
export interface CenterBasedSectionAppear {
  startSection: [number, number];
  zoom?: [number, number];
}
export interface FadeInOptions {
  zoom: [number, number];
}

export interface TextAnimationAction {
  colorize?: {
    color?: string;
    gradient?: string[];
    // This is from left and right 1 is default
    tranlate?: number;
  };
  blur?: {
    target: 'letter' | 'word' | 'line';
    range: number;
    // defulat is 30
    blur?: number;
    color?: string;
  };
}

export type ZoomDefinition = {
  // relative means that current segment's width compared to the cell segment
  type?: 'absolute' | 'relative';
  from?: number;
  to?: number;
  translate?: [number, number];
  duration?: number;
};

export type TranslateDefinition = {
  duration?: number;
  overlap?: number;
  type: 'absolute' | 'relative';
  origin?: 'center' | 'left-top' | 'right-top' | 'left-bottom' | 'right-bottom';
  from?: Coords;
  to?: Coords;
};
export interface TextAnimationStep {
  type?: 'appear' | 'disappear' | 'effect' | 'color-gradient';
  timeScale?: number;
  animationsByCell?: Record<string, TextAnimationStep>;
  target?: 'image' | 'text';
  nextSlideOverlap?: number;
  duration?: number;
  forceFade?: boolean;
  overlap?: number;
  delay?: number;
  ease?: 'linear' | 'fast-start' | 'fast-end' | 'ease' | 'overflow';
  zoom?: ZoomDefinition;
  translate?: TranslateDefinition;
  forEach?: boolean;
  effects?: {
    rowAppear: {
      itemDuration?: number;
      opts?: any;
      offset?: number;
      offsetDuration?: number;
    };
    dropShadow?: {
      target: 'letter' | 'word' | 'line';
      range: number;
      // defulat is 30
      blur?: number;
      color?: string;
    };
    colorize?: {
      target: 'letter' | 'word' | 'line';
      range: number;
      color?: string;
    };
    blink?: {
      cnt: number;
    };
  };
  line?: {
    // if the second is undefined then the rest of the line // -- // -- //
    type?: TransitionType;
    segment?: [number, number];
    zoom?: ZoomDefinition;
    translate?: TranslateDefinition;
    align?: 'static' | 'dynamic';
    alternate?: boolean;
    ease?: string;
    eases?: string[];
    textHide?: {
      except?: string;
    };
    segmentHighlight?: {
      lineOverlap?: number;
      wordOverlap?: number;
      color?: string;
      texts?: string[];
      target?: 'letter' | 'word' | 'line';
      range?: number;
      // defulat is 30
      blur?: number;
    };
    action?: {
      segment: [number, number];
      targetScale?: number;
      targetTranslate?: number;
      overlap?: number;
      translateDuration?: number;
    };
  };
  word?: {
    // if the second is undefined then the rest of the line //
    overlap?: number;
    noFade?: boolean;
    type?: TransitionType;
    segment?: number | [number, number];
    zoom?: [number, number];
    translate?: TranslateDefinition;
  };
  letter?: {
    noFade?: boolean;
    // if the second is undefined then the rest of the line //
    overlap?: number;
    type?: TransitionType;
    segment?: number | [number, number];
    zoom?: [number, number];
    translate?: TranslateDefinition;
  };
  action?: {
    index?: number;
    pulse?: {
      // alway center baded
      zoom: [number, number];
      cnt: number;
    };
    colorize?: {
      color?: string;
      gradient?: string[];
      // This is from left and right 1 is default
      tranlate?: number;
    };
    glove?: {
      // this is when a certain letter sections have drop-shadow and
      // and color patch goes through the word
      letterLength: number;
      color: string;
      gradient?: string[];
      duration?: number;
    };
    duration?: number;
    // -- // -- //
    bgGloveMotion?: Record<string, GloveDefinition>;
  };

  gloveMotion?: Record<
    string,
    {
      translate: [number, number];
      duration?: number;
    }
  >;

  next?: TextAnimationStep;
  paralell?: TextAnimationStep | TextAnimationStep[];
  sceneTransition?: SceneTransition;
}

export interface SceneTransition {
  duration?: number;
  from?: 'left' | 'right' | 'top' | 'bottom';
  overlap?: number;
  removeDelay?: number;
  delay?: number;
  hideGloves?: boolean;
  translate?: Coords;
}

@Injectable()
export class TextAnimationService {
  // -- //
  /*

  */
  // case -> zoom-segment
  // Center based zoom out and move to the left with overlap
  // -- //

  // I need a form for each type of action

  // I will have presets -> but I can customize on the UI

  // Presets

  // 1. Zoom out - zoom - in

  // 2. Zoom in segment - hshow the rest
  // steps
  /*
    - line.segment[0, 3].zoom.from = 0.5 -> to = 1.2 (ease can be overlap | not-overlap)
    - element.translates.left(overlap 0.5)
    - line.segment[3] fades in

    

    - next:
        - line:
            - segment: [3, 5]
            - type: 'fade'
  */

  // One action has a target. If not defined then the whole.
  // The element can have its own life -> zoom-in-out can be defined that way easier.

  // Exaples to describe
  // - 3 words float in from left |

  elementCase1(): TextAnimationStep {
    // Base element zooms in zooms out
    return {
      type: 'appear',
      zoom: {
        // think of the //
        type: 'absolute',
        from: 0.5,
        to: 1,
      },
      next: {
        type: 'disappear',
        duration: 0.5,
        zoom: {
          type: 'relative',
          to: 0.5,
        },
      },
    } as TextAnimationStep;
  }

  elementCase2() {
    // Note - lets say that an original

    // The element floats in as large text and zooms out to the center
    return {
      type: 'appear',
      zoom: {
        type: 'absolute',
        from: 0.5,
        to: 1,
      },
      next: {
        type: 'disappear',
        duration: 0.5,
        zoom: {
          type: 'relative',
          to: 0.5,
        },
      },
    } as TextAnimationStep;
  }

  case0() {
    // Segment zooms in and then the rest appears with a translate with overlay
    return {
      duration: 1,
      line: {
        segment: [0, 3],
      },
      zoom: {
        from: 0.5,
        to: 1,
      },
      next: {
        overlap: 0.5,
        duration: 1,
        zoom: {
          to: 1.2,
          translate: [0, -300],
        },
        paralell: {
          type: 'appear',
          line: {
            segment: [3, undefined],
          },
        },
      },
    } as TextAnimationStep;
  }

  case1() {
    // First word appears by letters so that the letters are coming from the bottom
    // Then the we zoom-in so that the whole line can be see // -- //
    return {
      duration: 1,
      line: {
        segment: [0, 1],
      },
      zoom: {
        // This defines that element should zoom in to the segment //
        type: 'absolute',
        from: 1,
      },
      // letter: {
      //   // in case the appearance the translate value is the from
      //   translate: [0, -100], //
      // },
      next: {
        duration: 0.5,
        line: {
          segment: [1, undefined],
          // type is undefined so they appear at once
        },
        zoom: {
          // Again I define that way that I zoom out to the current segment.
          type: 'absolute',
          to: 1,
        },
      },
    } as TextAnimationStep;
  }

  case3() {
    // First word appears by letters floating up, second letter appears by fade
    return {
      zoomToTarget: 1,
      zoom: {
        // this defines that no segment is required
        segment: [0, 2],
        from: 1,
      },
      line: {
        segment: [0, 1],
      },
      letter: {
        translate: [0, -100],
      },
      next: {
        duration: 0.5,
        line: {
          segment: [1],
        },
        letter: {
          type: 'fade',
        },
        zoom: {
          to: 1.3,
        },
      },
    };
  }

  case3_1() {
    // text just floats in with frame
  }

  _section_appear_case6() {
    // text zoom-in | word appear with translate up and fade | really dynamic //

    return {
      zoom: {
        to: 0.6,
      },
      word: {
        type: 'fade',
        translate: {
          type: 'relative',
          from: [0, -100],
        },
      },

      next: {
        zoom: {
          type: 'relative',
          to: 1.2,
        },
        action: {
          type: 'colorize',
        },
      },
    } as TextAnimationStep;
  }

  _transiation_tick() {
    // A line or word is switched with another so the the first line ticks real quick
    // this should be preceeded by smoother phase with some color or outline effect

    return {
      type: 'disappear',
      duration: 0.5,
      translate: {
        type: 'relative',
        to: [-50, 0],
      },
      next: {
        overlap: 0.2,
        type: 'appear',
        line: {
          segment: [1, 2],
        },
      },
    } as TextAnimationStep;
  }

  highlighSegmentThenShowComplete(ts: TextShape) {
    // In this case the segment doesn't zoom in.  It is shown in specific scale
    // and then the whole line is shown
  }

  scatter() {
    // The idea is to show the words of the line after each other
    // Each word should have a really large itself wr = 0.7
    // CAPITAL letter and randomly allocated -> dynamic type
  }

  // -- // This type of function returs and TextAnimationStep for a given line

  randomNWordAppear(n: number) {
    // 1. appear by fade
    const options = {
      'fade-in': {
        line: {
          segment: [0, n],
          type: 'fade',
        },
      },
      'word-by-word': {
        line: {
          segment: [0, n],
        },
        word: {},
      },
      'word-by-word-blue': {
        line: {
          segment: [0, n],
        },
        word: {
          type: 'blur',
        },
      },
    };
  }

  otherEffects() {
    // it sometime cool if a line moves left and right and lefts text-line appear dissapear
    // this is connected to the cursor effect
    // Transition
    // the screen is split into three lines
    // top and the bottom will change color with rectangles x: 0 -> width
    // the center rectangle comes with the same delay and brings the next line
    // Transition
    // zoom into a word
    // Simply the colorized letter is jumping around
    // Connect texts with glowing lines
    // Text rotation
    // A line of text appears between word of the current line in a rounded rectangle or
    // in a different color - which goes out from it
    // a gloving ball can move as well
    // or any combination of gloving lines
  }
}
